import { Pipe, PipeTransform } from '@angular/core';
import { Workarea } from '../workarea.class';

@Pipe({
    name: 'workareaPolygonOptions',
    standalone: false,
})
export class WorkareaPolygonOptionsPipe implements PipeTransform {
    transform(workarea: Workarea): google.maps.PolygonOptions {
        const color = '#' + workarea.status_colorcode;
        return {
            clickable: false,
            fillColor: color,
            fillOpacity: 0.35,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
        };
    }
}
